import { RefreshCw } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgRefreshArrow = mkIcon(RefreshCw);